import React, { useState } from 'react';

import { LoadingShimmer } from '@newsela/angelou';
import PropTypes from 'prop-types';

import { useRestQuery } from '@client/common/hooks';
import { isLocalEnv } from '@client/utils/environment';

import CrossWalkCard from '../CrosswalkCard';
import { $crosswalksContainer, $loadingContainer } from './style';
import Pagination from '../Pagination';

const MONOLITH_BASE_URL = isLocalEnv(window.location.hostname)
  ? 'https://app.dev.newseladev.com'
  : process.env.MONOLITH_BASE_URL;

const CrosswalksList = ({ standardId }) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const endpointPath = `/api/v3/content/delivery/metadata/standard/${standardId}/crosswalk/`;
  const params = new URLSearchParams({ page: (page + 1).toString(), page_size: pageSize.toString() });
  const LANGSTON_CROSSWALKS_ENDPOINT = `${MONOLITH_BASE_URL}${endpointPath}?${params}`;

  const { data: crosswalksData, loading, error } = useRestQuery(LANGSTON_CROSSWALKS_ENDPOINT);

  if (loading) {
    return (
      <div css={$loadingContainer}>
        <LoadingShimmer />
      </div>
    );
  }

  if (error) return <div>Error fetching crosswalks</div>;

  return (
    <div css={$crosswalksContainer}>
      {crosswalksData?.results.map((crosswalk) => (
        <CrossWalkCard key={crosswalk.id} crosswalk={crosswalk} />
      ))}
      <Pagination
        currentPage={page}
        pageSize={pageSize}
        total={crosswalksData?.total || 0}
        onPageChange={(page) => setPage(page)}
        onPageSizeChange={({ selectedItem }) => {
          setPageSize(selectedItem.value);
          setPage(0);
        }}
      />
    </div>
  );
};

CrosswalksList.propTypes = {
  standardId: PropTypes.string.isRequired,
};

export default CrosswalksList;
